export default {
    delete_note_title: "Delete Note",
    delete_note_success_message: "The note key has been deleted",
    delete_note_label: "Are you sure you want to delete the note?",
    delete_note_warning: "This action cannot be undone. This will permanently delete the data and its associations.",
}